function getEntity(keyEntities, key) {
  return keyEntities[key];
}
export { getEntity as default };
//# sourceMappingURL=keyUtil.js.map
